import { Component, OnInit, Inject, HostListener } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-carousel-dialog',
  templateUrl: './carousel-dialog.component.html',
  styleUrls: ['./carousel-dialog.component.scss']
})
export class CarouselDialogComponent implements OnInit {
  public slides = [];
  public currSlideIndex: number = 0;
  public windowWidth: number = window.innerWidth;
  public appName: string;
  public slideActiveStatus = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<CarouselDialogComponent>) { }
  ngOnInit() {
    this.appName = this.data.appName;
    for (let i in this.data.slides) {
      this.slides.push({
        image: this.data.fromFirstGuide ? this.data.slides[i] : this.data.imagePath + this.data.slides[i],
        index: i
      });
      if (this.data.currSlide + '' === this.data.slides[i] + '') {
        this.currSlideIndex = this.slides[i].index;
        this.slideActiveStatus.push(true);
      }
      else {
        this.slideActiveStatus.push(false);
      }
    }
  }

  @HostListener('window:keydown.ArrowRight', ['$event'])
  arrowRightClickHandler(event: KeyboardEvent) {
    if (event.key === 'arrow right' && (this.currSlideIndex < this.slides.length - 1)) {
      this.setActive(parseInt(this.currSlideIndex + '') + 1);
    }
  }

  @HostListener('window:keydown.ArrowLeft', ['$event'])
  arrowLeftClickHandler(event: KeyboardEvent) {
    if (event.key === 'arrow left' && (this.currSlideIndex > 0)) {
      this.setActive(parseInt(this.currSlideIndex + '') - 1);
    }
  }

  public getCurrentIndex(idx) {
    return (this.getCurrentIndex === idx ? true : false);
  }

  public setActive(idx) {
    this.currSlideIndex = idx;
    for (let i in this.slideActiveStatus) {
      if (i == idx) {
        this.slideActiveStatus[i] = true;
      }
      else {
        this.slideActiveStatus[i] = false;
      }
    }
  }

  public clickOutsideCloseDialog(event) {
    const temp = document.getElementById('carousel-img');
    const temp1 = document.getElementsByClassName('thumbnail-image');
    const temp2 = temp.contains(event.target);
    let temp3 = false;
    for (let i = 0; i < temp1.length; i++) {
      temp3 = temp1[i].contains(event.target);
      if (temp3) {
        break;
      }
    }
    if ((!temp2) && (!temp3)) {
      this.dialogRef.close();
    }
  }
}
